module.exports = __webpack_public_path__ + "img/question.75cef339.svg";